import { all, fork } from 'redux-saga/effects';
import Common from './common';

export default function* root() {
    yield all([
        fork(Common)
    ])
}
